import React, { ComponentPropsWithRef, FC } from 'react';
import { PlcImgLoader } from '@components/Loaders/PlcImgLoader.component';
import { PlcTextListLoader } from '@components/Loaders/PlcTextLoader.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { Spacing } from '@styles/Spacing.style';
import classnames from 'classnames';
import styles from './ContentCardJournalVersion.module.scss';

type Props = ComponentPropsWithRef<'article'> & { uniqueKey?: string };

const ContentCardLoaderJournalVersion: FC<Props> = ({ className, uniqueKey = 'my-random-value', ...rest }) => {
  const rootClass = classnames(styles['content-card'], 'flex new-grid-m-2-s-2', className);
  const isMobile = useIsBreakpointDown(Breakpoint.m);
  const width = 325;
  return (
    <article className={rootClass} {...rest}>
      <header>
        <div className="plc-mr-m">
          <PlcImgLoader height={isMobile ? 90 : 120} uniqueKey={`${uniqueKey}-img`} width={isMobile ? 210 : 220} />
        </div>
      </header>
      <div>
        <PlcTextListLoader
          textProps={[
            { bottomSpacing: Spacing.xxs, variant: 'tiny-title', width: 75 },
            { bottomSpacing: Spacing.m, numberOfLine: 3, variant: 'new-h3', width: 0.7 * width },
            { variant: 'p', width: 140 },
          ]}
          uniqueKey={`${uniqueKey}-txt`}
          width={width}
        />
      </div>
    </article>
  );
};

export { ContentCardLoaderJournalVersion };
